import { useEffect, useState } from "react";
import { publicList } from "../admin/api";
import {
  PROFILE,
  CREDENTIALS,
  AWARDS,
  EXPERIENCES,
  PROJECTS,
  SKILLS,
  PLACES,
} from "../cv/data";

const merge = (adminList, staticList) => {
  if (!Array.isArray(adminList) || adminList.length === 0) return staticList;
  const ids = new Set(adminList.map((x) => x.id));
  return [...adminList, ...staticList.filter((x) => !ids.has(x.id))];
};

/* Aggregate every piece of data the resume templates might need. */
export function useResumeData() {
  const [state, setState] = useState({
    profile: PROFILE,
    credentials: CREDENTIALS,
    awards: AWARDS,
    experiences: EXPERIENCES,
    projects: PROJECTS,
    skills: SKILLS,
    places: PLACES,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    const fetchAll = async () => {
      const [cred, aw, exp, proj, sk, pl] = await Promise.all([
        publicList("credentials").catch(() => []),
        publicList("awards").catch(() => []),
        publicList("experiences").catch(() => []),
        publicList("projects").catch(() => []),
        publicList("skills").catch(() => []),
        publicList("places").catch(() => []),
      ]);
      if (cancelled) return;
      setState({
        profile: PROFILE,
        credentials: merge(cred, CREDENTIALS),
        awards: merge(aw, AWARDS),
        experiences: merge(exp, EXPERIENCES),
        projects: merge(proj, PROJECTS),
        skills: merge(sk, SKILLS),
        places: merge(pl, PLACES),
        loading: false,
      });
    };
    fetchAll();
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
